// extracted by mini-css-extract-plugin
module.exports = {"item":"NavigationItem_item__1ortn"};